import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, of, switchMap } from "rxjs";
import * as inviteUserAction from '../actions/invite-user.action';
import { ApiService } from '../../../../SGRE-shared/services/api.service';
import { companyListState } from "../invite-user.state";
import { GlobalService } from '../../../../SGRE-shared/services/global.service';
import { InviteUserEffectsService } from './inviteUserEffect.service'
import * as internalSubmitAction from '../actions/submit-InviteUser.action'
import { ErrorType } from "../../../../SGRE-config/error-config";
import { inviteUserRoles } from "../../models/invite-user.model";
import { LoggerService, tryNormalizeHttpError } from "@spartacus/core";

@Injectable()
export class InviteUserEffects {

  protected logger = inject(LoggerService);

  constructor(
    private actions: Actions,
    private apiService: ApiService,
    private globalService: GlobalService,
    private InviteUserEffectService: InviteUserEffectsService
  ) { }

  fetchCompanyNameList$ = createEffect(() =>
    this.actions.pipe(
      ofType(inviteUserAction.getCompanyNameList),
      switchMap((action) =>
        this.apiService.getCompanyList(action.payload)
          .pipe(
            map((data: companyListState) => {
              this.globalService.loadingSubject.next(false);
              return inviteUserAction.getCompanyNameListSuccess({ companyList: data })
            }),
            catchError((error) => of(inviteUserAction.getCompanyNameListFail({ payload: tryNormalizeHttpError(error, this.logger) })))
          )
      ),
    )
  );

  submitInternalInviteUser$ = createEffect(() =>
    this.actions.pipe(
      ofType(internalSubmitAction.submitInviteUserAction),
      switchMap((action) => {
        const payload = this.InviteUserEffectService.getSubmitPayload();
        const Api$ = payload.user === inviteUserRoles.INTERNAL
          ? this.apiService.postLegalEntityListInternal(payload.requestArray, payload.params)
          : this.apiService.postLegalEntityListExteral(payload.requestArray, payload.params);
        return Api$.pipe(
          map((data) => {
            this.globalService.loadingSubject.next(false);
            return internalSubmitAction.submitInviteUserResponce({ submitResponse: data.status });
          }),
          catchError((error) => {
            this.globalService.clearMessagesOnDestroy(ErrorType.WARNING),
              this.globalService.loadingSubject.next(false);
              this.InviteUserEffectService.checkError( error.error.errors[0].message);
            return of(internalSubmitAction.submitInviteUserResponce({ submitResponse: error.error.errors[0].message }));
          })
        );
      })
    )
  );
}
